"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[726],{

/***/ 78196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ setContractLastManuallyVerified; },
/* harmony export */   "N$": function() { return /* binding */ useContractsFreshness; },
/* harmony export */   "O$": function() { return /* binding */ setContractCategory; },
/* harmony export */   "pG": function() { return /* binding */ setContractTwitterHandle; },
/* harmony export */   "pv": function() { return /* binding */ setContractName; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23855);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66604);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20929);




const setContractTwitterHandle = async (address, handle, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-twitter-handle?address=").concat(address, "&token=").concat(token, "&handle=").concat(handle));
    if (res.status !== 200) {
        console.error("failed to add twitter handle", await res.json());
        return;
    }
    console.log("successfully twitter handle ".concat(handle, " for ").concat(address));
};
const setContractName = async (address, name, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-name?address=").concat(address, "&token=").concat(token, "&name=").concat(name));
    if (res.status !== 200) {
        console.error("failed to add contract name", await res.json());
        return;
    }
    console.log("successfully added contract name ".concat(name, " for ").concat(address));
};
const setContractCategory = async (address, category, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-category?address=").concat(address, "&token=").concat(token, "&category=").concat(category));
    if (res.status !== 200) {
        console.error("failed to add contract category", await res.json());
        return;
    }
    console.log("successfully added category ".concat(category, " for ").concat(address));
};
const setContractLastManuallyVerified = async (address, token)=>{
    if (token === undefined) {
        return;
    }
    const res = await fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/admin/set-last-manually-verified?address=").concat(address, "&token=").concat(token));
    if (res.status !== 200) {
        console.error("failed to add contract category", await res.json());
        return;
    }
    console.log("successfully set last manually verified for ".concat(address));
};
const decodeFreshness = (freshness)=>({
        openseaContractLastFetch: freshness.openseaContractLastFetch == null ? undefined : date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(freshness.openseaContractLastFetch),
        lastManuallyVerified: freshness.lastManuallyVerified == null ? undefined : date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(freshness.lastManuallyVerified)
    });
const useContractsFreshness = (addresses, token)=>{
    const shouldFetch = addresses !== undefined && token !== undefined;
    const fetcher = (url)=>fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                addresses
            })
        }).then(async (res)=>{
            if (!res.ok) {
                console.log(await res.json());
                throw new Error("failed to fetch contract metadata freshness");
            }
            return res.json();
        });
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(shouldFetch ? "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .getApiDomain */ .A(), "/api/contracts/metadata-freshness?token=").concat(token) : null, fetcher);
    return data === undefined ? undefined : lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default()(data, decodeFreshness);
};


/***/ }),

/***/ 13983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useScarcity; }
/* harmony export */ });
/* unused harmony export fetchScarcity */
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39499);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsbi__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5964);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78051);
/* harmony import */ var _supply_projection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97355);





const jsbiFromBigIntString = (str)=>jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(str.slice(0, -1));
const url = "/api/fees/scarcity";
const fetchScarcity = ()=>fetchApiJson(url);
const useScarcity = ()=>{
    var ref, ref1;
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(url, _fetchers__WEBPACK_IMPORTED_MODULE_2__/* .fetchJsonSwr */ .Ar, {
        refreshInterval: _duration__WEBPACK_IMPORTED_MODULE_4__/* .millisFromHours */ .QN(1)
    });
    const supplyProjectionInputs = (0,_supply_projection__WEBPACK_IMPORTED_MODULE_3__/* .useSupplyProjectionInputs */ .k)();
    // We use an SWRConfig with fallback data for this hook.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const safeData = data;
    var ref2;
    return {
        engines: {
            burned: {
                ...safeData.engines.burned,
                startedOn: new Date(safeData.engines.burned.startedOn),
                amount: jsbiFromBigIntString(safeData.engines.burned.amount)
            },
            locked: {
                ...safeData.engines.locked,
                amount: (ref2 = supplyProjectionInputs === null || supplyProjectionInputs === void 0 ? void 0 : (ref = supplyProjectionInputs.inContractsByDay) === null || ref === void 0 ? void 0 : (ref1 = ref[(supplyProjectionInputs === null || supplyProjectionInputs === void 0 ? void 0 : supplyProjectionInputs.inContractsByDay.length) - 1]) === null || ref1 === void 0 ? void 0 : ref1.v) !== null && ref2 !== void 0 ? ref2 : 0,
                startedOn: new Date(safeData.engines.locked.startedOn)
            },
            staked: {
                ...safeData.engines.staked,
                startedOn: new Date(safeData.engines.staked.startedOn),
                amount: jsbiFromBigIntString(safeData.engines.staked.amount)
            }
        },
        ethSupply: jsbiFromBigIntString(safeData.ethSupply),
        number: safeData.number
    };
};


/***/ }),

/***/ 97355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useSupplyProjectionInputs; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78051);


const useSupplyProjectionInputs = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("/api/v2/fees/supply-projection-inputs", _fetchers__WEBPACK_IMPORTED_MODULE_1__/* .fetchJsonSwr */ .Ar);
    return data;
};


/***/ }),

/***/ 45318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AdminControls; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(36948);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__(59910);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMethods = __webpack_require__(93645);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInHours/index.js




/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = (0,differenceInMilliseconds/* default */.Z)(dateLeft, dateRight) / constants/* millisecondsInHour */.vh;
  return (0,roundingMethods/* getRoundingMethod */.u)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceStrict/index.js + 3 modules
var formatDistanceStrict = __webpack_require__(63016);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js


/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */

function formatDistanceToNowStrict(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,formatDistanceStrict/* default */.Z)(dirtyDate, Date.now(), options);
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-admin-token.ts
var use_admin_token = __webpack_require__(11331);
// EXTERNAL MODULE: ./src/mainsite/api/contracts.ts
var contracts = __webpack_require__(78196);
;// CONCATENATED MODULE: ./src/mainsite/components/AdminControls.tsx





const onSetTwitterHandle = async (address, token)=>{
    const handle = window.prompt("input twitter handle");
    if (handle === null) {
        return;
    }
    await contracts/* setContractTwitterHandle */.pG(address, handle, token);
};
const onSetName = async (address, token)=>{
    const nameInput = window.prompt("input name");
    if (nameInput === null) {
        return;
    }
    await contracts/* setContractName */.pv(address, nameInput, token);
};
const onSetCategory = async (address, token)=>{
    const category = window.prompt("input category");
    if (category === null) {
        return;
    }
    await contracts/* setContractCategory */.O$(address, category, token);
};
const getOpacityFromAge = (now, dt)=>dt === undefined || now === undefined ? 0.8 : Math.min(0.8, 0.2 + 0.6 / 168 * differenceInHours(now, dt));
const AdminControls = (param)=>{
    let { address , freshness  } = param;
    const adminToken = (0,use_admin_token/* useAdminToken */.F)();
    const [now, setNow] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        setNow(new Date());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-4 opacity-80",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            onSetTwitterHandle(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set handle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            onSetName(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            onSetCategory(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set category"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "cursor-pointer text-pink-300 hover:text-pink-300 hover:opacity-60",
                        onClick: ()=>{
                            contracts/* setContractLastManuallyVerified */.IX(address, adminToken).catch(console.error);
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        children: "set verified"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 flex gap-x-4 text-sm text-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "rounded-lg bg-slate-700 py-1 px-2",
                        style: {
                            opacity: getOpacityFromAge(now, freshness === null || freshness === void 0 ? void 0 : freshness.openseaContractLastFetch)
                        },
                        children: (freshness === null || freshness === void 0 ? void 0 : freshness.openseaContractLastFetch) === undefined ? "never fetched" : "opensea fetch ".concat(formatDistanceToNowStrict(freshness.openseaContractLastFetch), " ago")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "rounded-lg bg-slate-700 py-1 px-2",
                        style: {
                            opacity: getOpacityFromAge(now, freshness === null || freshness === void 0 ? void 0 : freshness.lastManuallyVerified)
                        },
                        children: (freshness === null || freshness === void 0 ? void 0 : freshness.lastManuallyVerified) === undefined ? "never verified" : "last verified ".concat(formatDistanceToNowStrict(freshness.lastManuallyVerified), " ago")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AdminControls = (AdminControls);


/***/ }),

/***/ 17726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_TotalValueSecuredSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/duration.ts
var duration = __webpack_require__(5964);
// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/total-value-secured.ts



const useTotalValueSecured = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/fees/total-value-secured", fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromSeconds */.Io(10)
    });
    return data;
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./src/format.ts
var format = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/mainsite/components/Amount.tsx
var Amount = __webpack_require__(30772);
// EXTERNAL MODULE: ./src/components/DefaultLink.tsx
var DefaultLink = __webpack_require__(39469);
// EXTERNAL MODULE: ./src/mainsite/components/Modal.tsx
var Modal = __webpack_require__(33181);
// EXTERNAL MODULE: ./src/components/TextsNext/BodyText.tsx
var BodyText = __webpack_require__(68539);
// EXTERNAL MODULE: ./src/components/WidgetSubcomponents/index.tsx
var WidgetSubcomponents = __webpack_require__(69443);
// EXTERNAL MODULE: ./node_modules/jsbi/dist/jsbi-umd.js
var jsbi_umd = __webpack_require__(39499);
var jsbi_umd_default = /*#__PURE__*/__webpack_require__.n(jsbi_umd);
// EXTERNAL MODULE: ./node_modules/lodash/flow.js
var flow = __webpack_require__(59242);
var flow_default = /*#__PURE__*/__webpack_require__.n(flow);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var react_loading_skeleton_dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./src/mainsite/api/eth-price-stats.ts
var eth_price_stats = __webpack_require__(92679);
// EXTERNAL MODULE: ./src/mainsite/api/scarcity.ts
var scarcity = __webpack_require__(13983);
// EXTERNAL MODULE: ./src/assets/round-nerd-large.svg
var round_nerd_large = __webpack_require__(92537);
// EXTERNAL MODULE: ./src/feature-flags.ts
var feature_flags = __webpack_require__(58739);
// EXTERNAL MODULE: ./src/mainsite/components/Spacing.tsx
var Spacing = __webpack_require__(57845);
// EXTERNAL MODULE: ./src/components/Texts.tsx
var Texts = __webpack_require__(90917);
;// CONCATENATED MODULE: ./src/mainsite/components/TotalValueSecured/TooltipSecurityRatio.tsx
















const formatEthPrice = (ethPrice, ethStaked)=>flow_default()(// We scale up a little, the numbers are huge, let's not drop precision we have.
    ()=>Math.round(ethPrice.usd * 1e2), (ethPriceCentsFloat)=>jsbi_umd_default().BigInt(ethPriceCentsFloat), (ethPriceCentsBI)=>jsbi_umd_default().multiply(ethStaked.amount, ethPriceCentsBI), // 1e18 is Wei -> ETH, 1e12 is displaying in trillions, 1e2 is scaling down from using cents not dollars above.
    // We then leave four orders of size, because we expect a number < 0, which a bigint cannot hold.
    (num)=>jsbi_umd_default().divide(num, jsbi_umd_default().BigInt(1e12 * 1e18 * 1e2 * 1e-4)), // We then leave
    (num)=>jsbi_umd_default().toNumber(num) / 1e4, format/* formatTwoDigit */.cI)();
const TooltipSecurityRatio = (param)=>{
    let { onClickClose  } = param;
    var ref;
    const ethPriceStats = (0,eth_price_stats/* useEthPriceStats */.U)();
    const totalValueSecured = useTotalValueSecured();
    const ethStaked = (ref = (0,scarcity/* useScarcity */.r)()) === null || ref === void 0 ? void 0 : ref.engines.staked;
    const { previewSkeletons  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: "\n        relative\n        flex w-[22rem] flex-col\n        gap-y-4 rounded-lg border\n        border-slateus-400 bg-slateus-700\n        p-8\n      ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "a close button, circular with an x in the middle",
                className: "absolute right-5 top-5 w-6 cursor-pointer select-none hover:brightness-90 active:brightness-110",
                onClick: onClickClose,
                src: "/close.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "",
                className: "mx-auto h-20 w-20 select-none rounded-full",
                src: round_nerd_large/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                className: "font-semibold",
                children: "security ratio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                    className: "whitespace-pre-wrap md:leading-normal",
                    children: "The ratio of total value secured (TVS) to economic security. It measures attacker leverage—lower is better."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                children: "formula"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                        children: "="
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-2 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                children: "total value secured"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "h-[1px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                children: "economic security"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                        children: "="
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-2 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                children: "value secured by Ethereum"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "h-[1px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                children: "value securing Ethereum"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center text-base",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                        children: "="
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-2 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                                        font: "font-roboto",
                                        children: [
                                            totalValueSecured === undefined || previewSkeletons ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                                inline: true,
                                                width: "2.4rem"
                                            }) : format/* formatTwoDigit */.cI(totalValueSecured.sum / 1e12),
                                            "T"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* UnitText */.f4, {
                                        children: "USD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                        font: "font-inter",
                                        weight: "font-extralight",
                                        color: "text-slateus-200",
                                        children: "in ETH, ERC20s, NFTs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "h-[1px]"
                            }),
                            totalValueSecured === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                inline: true,
                                width: "2rem"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts/* BaseText */.k$, {
                                        font: "font-roboto",
                                        children: [
                                            ethStaked === undefined || previewSkeletons ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                                inline: true,
                                                width: "2.4rem"
                                            }) : formatEthPrice(ethPriceStats, ethStaked),
                                            "T"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* UnitText */.f4, {
                                        children: "USD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacing/* AmountUnitSpace */.V, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Texts/* BaseText */.k$, {
                                        color: "text-slateus-200",
                                        font: "font-inter",
                                        weight: "font-extralight",
                                        children: "in staked ETH"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TotalValueSecured_TooltipSecurityRatio = (TooltipSecurityRatio);

;// CONCATENATED MODULE: ./src/mainsite/components/TotalValueSecured/Summary.tsx











const AssetType = (param)=>{
    let { alt , href , icon , title , amount  } = param;
    const [isHovering, setIsHovering] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultLink/* default */.Z, {
        className: "relative flex items-center justify-between",
        href: href,
        onMouseEnter: ()=>setIsHovering(true),
        onMouseLeave: ()=>setIsHovering(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: alt,
                        className: "select-none ".concat(isHovering ? "invisible" : "visible"),
                        src: "/round-".concat(icon, "-coloroff.svg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "absolute top-0 select-none ".concat(isHovering ? "visible" : "invisible"),
                        src: "/round-".concat(icon, "-coloron.svg"),
                        alt: alt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                        className: "\n            ml-4\n          ",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* AmountBillionsUsdAnimated */.BG, {
                size: "text-base md:text-lg",
                tooltip: amount === undefined ? undefined : "".concat(format/* formatZeroDecimals */.UY(amount), " USD"),
                children: amount
            })
        ]
    });
};
const Summary = (param)=>{
    let { className =""  } = param;
    const totalValueSecured = useTotalValueSecured();
    const [showSecurityRatioTooltip, setShowSecurityRatioTooltip] = (0,react.useState)(false);
    const [isHoveringNerd, setIsHoveringNerd] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetBackground */.K, {
                className: "h-min ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "-mt-1 mb-2 flex flex-col gap-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-y-4 md:flex-row md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-4",
                                    title: totalValueSecured === undefined ? undefined : "".concat(format/* formatZeroDecimals */.UY(totalValueSecured.sum), " USD"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                            children: "total value secured"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* AmountTrillionsUsdAnimated */.gn, {
                                            skeletonWidth: "8rem",
                                            size: "text-2xl md:text-3xl xl:text-4xl",
                                            children: totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.sum
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex cursor-pointer flex-col gap-y-4 md:items-end",
                                    onClick: ()=>setShowSecurityRatioTooltip(true),
                                    onMouseEnter: ()=>setIsHoveringNerd(true),
                                    onMouseLeave: ()=>setIsHoveringNerd(false),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                                                    children: "security ratio"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "an emoji of a nerd",
                                                    className: "ml-2 select-none ".concat(isHoveringNerd ? "hidden" : ""),
                                                    src: "/nerd-coloroff.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "an colored emoji of a nerd",
                                                    className: "ml-2 select-none ".concat(isHoveringNerd ? "" : "hidden"),
                                                    src: "/nerd-coloron.svg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* AmountAnimatedShell */.au, {
                                            skeletonWidth: "5rem",
                                            size: "text-2xl md:text-3xl xl:text-4xl",
                                            children: (totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.securityRatio) === undefined ? undefined : /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                                decimals: 1,
                                                duration: 0.8,
                                                end: totalValueSecured.securityRatio,
                                                preserveValue: true,
                                                suffix: "x"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                            children: "ethereum secures"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetType, {
                            amount: totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.ethTotal,
                            href: "https://etherscan.io/stat/supply",
                            icon: "eth",
                            title: "ETH"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetType, {
                            amount: totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.erc20Total,
                            href: "https://www.coingecko.com/?asset_platform_id=ethereum",
                            icon: "erc20",
                            title: "ERC20s"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetType, {
                            amount: totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.nftTotal,
                            href: "https://nftgo.io/analytics/top-collections",
                            icon: "nft",
                            title: "NFTs"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                onClickBackground: ()=>setShowSecurityRatioTooltip(false),
                show: showSecurityRatioTooltip,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalValueSecured_TooltipSecurityRatio, {
                    onClickClose: ()=>setShowSecurityRatioTooltip(false)
                })
            })
        ]
    });
};
/* harmony default export */ var TotalValueSecured_Summary = (Summary);

// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(95237);
// EXTERNAL MODULE: ./src/hooks/use-admin-token.ts
var use_admin_token = __webpack_require__(11331);
// EXTERNAL MODULE: ./src/mainsite/api/contracts.ts
var contracts = __webpack_require__(78196);
// EXTERNAL MODULE: ./src/styles/Scrollbar.module.scss
var Scrollbar_module = __webpack_require__(23195);
var Scrollbar_module_default = /*#__PURE__*/__webpack_require__.n(Scrollbar_module);
// EXTERNAL MODULE: ./src/mainsite/utils/use-active-breakpoint.ts
var use_active_breakpoint = __webpack_require__(95251);
// EXTERNAL MODULE: ./src/mainsite/components/AdminControls.tsx + 2 modules
var AdminControls = __webpack_require__(45318);
// EXTERNAL MODULE: ./src/mainsite/components/ImageWithTooltip.tsx + 1 modules
var ImageWithTooltip = __webpack_require__(13852);
// EXTERNAL MODULE: ./src/mainsite/components/FamTooltip.tsx + 1 modules
var FamTooltip = __webpack_require__(93964);
// EXTERNAL MODULE: ./src/components/TextsNext/SkeletonText.tsx
var SkeletonText = __webpack_require__(7569);
;// CONCATENATED MODULE: ./src/mainsite/components/TotalValueSecured/TvsLeaderboard.tsx


















const TvsLeaderboard = (param)=>{
    let { className ="" , maxHeight ="" , rows , title  } = param;
    var ref, ref1;
    const { md  } = (0,use_active_breakpoint/* useActiveBreakpoint */.P)();
    const adminToken = (0,use_admin_token/* useAdminToken */.F)();
    // Tooltip logic should be abstracted. See BurnLeaderboard tooltip. The abstraction over there could also be made more generic to support this if that makes sense instead of copying.
    // Popper Tooltip
    const [refEl, setRefEl] = (0,react.useState)(null);
    const [popperEl, setPopperEl] = (0,react.useState)(null);
    const { styles , attributes  } = (0,usePopper/* usePopper */.D)(refEl, popperEl, {
        placement: "right",
        modifiers: [
            {
                name: "flip"
            }
        ]
    });
    const [selectedRanking, setSelectedRanking] = (0,react.useState)();
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const onTooltip = (0,react.useRef)(false);
    const onImage = (0,react.useRef)(false);
    const handleImageMouseEnter = (0,react.useCallback)((ranking, ref)=>{
        // The ranking data isn't there yet so no tooltip can be shown.
        if (ranking === undefined) {
            return;
        }
        onImage.current = true;
        const id = window.setTimeout(()=>{
            setRefEl(ref.current);
            setSelectedRanking(ranking);
            setShowTooltip(true);
        }, 300);
        return ()=>window.clearTimeout(id);
    }, []);
    const handleImageMouseLeave = (0,react.useCallback)(()=>{
        onImage.current = false;
        const id = window.setTimeout(()=>{
            if (!onImage.current && !onTooltip.current) {
                setShowTooltip(false);
                setSelectedRanking(undefined);
            }
        }, 300);
        return ()=>window.clearTimeout(id);
    }, []);
    const handleTooltipEnter = (0,react.useCallback)(()=>{
        onTooltip.current = true;
    }, []);
    const handleTooltipLeave = (0,react.useCallback)(()=>{
        onTooltip.current = false;
        const id = window.setTimeout(()=>{
            if (!onImage.current && !onTooltip.current) {
                setShowTooltip(false);
                setSelectedRanking(undefined);
            }
        }, 100);
        return ()=>window.clearTimeout(id);
    }, []);
    const handleClickProfile = (0,react.useCallback)((ranking)=>{
        setSelectedRanking(ranking);
        if (md) {
            setShowTooltip(true);
        } else {
            setShowModal(true);
        }
    }, [
        md
    ]);
    const leaderboardSkeletons = new Array(100).fill({});
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const addresses = rows === null || rows === void 0 ? void 0 : rows.map((row)=>row.contractAddresses[0]);
    const freshnessMap = (0,contracts/* useContractsFreshness */.N$)(addresses, adminToken);
    const { showMetadataTools  } = (0,react.useContext)(feature_flags/* FeatureFlagsContext */.JN);
    var ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetSubcomponents/* WidgetBackground */.K, {
                className: "flex flex-col gap-y-4 overflow-x-auto ".concat(className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetSubcomponents/* WidgetTitle */.P, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "\n            flex flex-col\n            overflow-y-auto ".concat(maxHeight, "\n            -mr-3\n            h-full gap-y-4\n            pr-2\n            ").concat((Scrollbar_module_default())["styled-scrollbar-vertical"], "\n            ").concat((Scrollbar_module_default())["styled-scrollbar"], "\n          "),
                        children: (rows || leaderboardSkeletons).map((row, index)=>{
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "flex items-center text-white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTooltip/* default */.Z, {
                                                className: "h-8 w-8 select-none",
                                                imageUrl: row === null || row === void 0 ? void 0 : row.imageUrl,
                                                isDoneLoading: row !== undefined,
                                                onMouseEnter: (ref)=>row === undefined ? ()=>undefined : handleImageMouseEnter(row, ref),
                                                onMouseLeave: ()=>handleImageMouseLeave(),
                                                onClick: ()=>row === undefined ? ()=>undefined : handleClickProfile(row),
                                                height: 32,
                                                width: 32
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultLink/* default */.Z, {
                                                className: "ml-4 flex w-full justify-between overflow-hidden",
                                                href: (row === null || row === void 0 ? void 0 : row.coinGeckoUrl) || (row === null || row === void 0 ? void 0 : row.nftGoUrl),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                                        className: "truncate",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText/* default */.Z, {
                                                            width: "6rem",
                                                            children: row === null || row === void 0 ? void 0 : (ref = row.name) === null || ref === void 0 ? void 0 : ref.split(":")[0]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* default */.Z, {
                                                        className: "\n                      ml-2 mr-auto hidden\n                      pr-2 font-extralight uppercase\n                      text-slateus-400 ".concat((row === null || row === void 0 ? void 0 : row.detail) !== undefined ? "md:inline" : "", "\n                    "),
                                                        children: row === null || row === void 0 ? void 0 : row.detail
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Amount/* AmountBillionsUsdAnimated */.BG, {
                                                        tooltip: row !== undefined ? "".concat(format/* formatZeroDecimals */.UY(row.marketCap), " USD") : undefined,
                                                        children: row === null || row === void 0 ? void 0 : row.marketCap
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    adminToken !== undefined && row !== undefined && freshnessMap !== undefined && showMetadataTools && row.contractAddresses[0] !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminControls/* default */.Z, {
                                        address: row.contractAddresses[0],
                                        freshness: row !== undefined ? freshnessMap[row.contractAddresses[0]] : undefined
                                    })
                                ]
                            }, (ref2 = row === null || row === void 0 ? void 0 : row.name) !== null && ref2 !== void 0 ? ref2 : index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: setPopperEl,
                        className: "z-20 hidden p-4 md:block",
                        style: {
                            ...styles.popper,
                            visibility: showTooltip ? "visible" : "hidden"
                        },
                        ...attributes.popper,
                        onMouseOver: handleTooltipEnter,
                        onMouseOut: handleTooltipLeave,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FamTooltip/* default */.Z, {
                            contractAddresses: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.contractAddresses,
                            coingeckoUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.coinGeckoUrl,
                            description: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.tooltipDescription,
                            famFollowerCount: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.famFollowerCount,
                            followerCount: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.followerCount,
                            imageUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.imageUrl,
                            links: (ref3 = selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.links) !== null && ref3 !== void 0 ? ref3 : undefined,
                            nftGoUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.nftGoUrl,
                            onClickClose: ()=>setShowTooltip(false),
                            title: selectedRanking === null || selectedRanking === void 0 ? void 0 : (ref = selectedRanking.tooltipName) === null || ref === void 0 ? void 0 : ref.split(":")[0],
                            twitterUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.twitterUrl,
                            width: "min-w-[18rem] max-w-sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        onClickBackground: ()=>setShowModal(false),
                        show: showModal,
                        children: selectedRanking !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(FamTooltip/* default */.Z, {
                            contractAddresses: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.contractAddresses,
                            coingeckoUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.coinGeckoUrl,
                            description: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.tooltipDescription,
                            famFollowerCount: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.famFollowerCount,
                            followerCount: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.followerCount,
                            imageUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.imageUrl,
                            links: (ref4 = selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.links) !== null && ref4 !== void 0 ? ref4 : undefined,
                            nftGoUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.nftGoUrl,
                            onClickClose: ()=>setShowModal(false),
                            title: selectedRanking === null || selectedRanking === void 0 ? void 0 : (ref1 = selectedRanking.tooltipName) === null || ref1 === void 0 ? void 0 : ref1.split(":")[0],
                            twitterUrl: selectedRanking === null || selectedRanking === void 0 ? void 0 : selectedRanking.twitterUrl,
                            width: "min-w-[18rem] max-w-sm"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TotalValueSecured_TvsLeaderboard = (TvsLeaderboard);

// EXTERNAL MODULE: ./src/components/Section.tsx
var Section = __webpack_require__(33040);
;// CONCATENATED MODULE: ./src/mainsite/sections/TotalValueSecuredSection.tsx





const TotalValueSecuredSection = ()=>{
    const totalValueSecured = useTotalValueSecured();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        title: "total value secured—TVS",
        link: "tvs",
        subtitle: "securing the internet of value",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid w-full gap-4 lg:grid-cols-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalValueSecured_Summary, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalValueSecured_TvsLeaderboard, {
                    className: "lg:col-start-2 lg:row-start-1 lg:row-end-3",
                    rows: totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.erc20Leaderboard,
                    title: "erc20 leaderboard",
                    maxHeight: "max-h-[23rem] lg:max-h-[564px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalValueSecured_TvsLeaderboard, {
                    className: "-mt-1",
                    rows: totalValueSecured === null || totalValueSecured === void 0 ? void 0 : totalValueSecured.nftLeaderboard,
                    title: "nft leaderboard",
                    maxHeight: "max-h-[224px]"
                })
            ]
        })
    });
};
/* harmony default export */ var sections_TotalValueSecuredSection = (TotalValueSecuredSection);


/***/ })

}]);